import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/apply-avatar.jpg'
import _imports_1 from '@/assets/images/apply-poster.jpg'


const _withScopeId = n => (_pushScopeId("data-v-cbcacece"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = {
  href: "https://docs.vrchat.com/docs/submitting-a-world-to-be-made-public#avatar-worlds--all-avatar-pedestals-in-any-world",
  target: "_blank"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-apply" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_6')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_3')), 1),
          _createVNode(_component_LinkButton, {
            href: "",
            "is-disabled": true,
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_6')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_1, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_4')), 1),
          _hoisted_2,
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_5')), 1),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_6')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_5')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_3')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_2')), 1),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'li_text_1')) + " ", 1),
              _createVNode(_component_SignalText, { signal: "caution" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'li_text_2')) + " ", 1),
                  _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'li_link')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'li_text_3')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_th_1')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_th_2')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_1')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_2')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_3')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_4')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_5')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_6')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_7')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_8')), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_9')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$props.i18n.$text('li_avatar_req', 'avatar_td_10')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_3')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_5')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_6')), 1)
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_1')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_LinkButton, {
            href: "",
            "is-disabled": true,
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_6')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", null, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_7')), 1),
          _hoisted_4,
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_4')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_8')), 1),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_5')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_9')), 1),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_7')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h3_6')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_7')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_8')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_9')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_10')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_12')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('li_11')), 1)
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_4')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_8')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_LinkButton, {
            href: "",
            "is-disabled": true,
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_6')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}